import { createIcon } from '@chakra-ui/icons';

export const CheckCircleOutline = createIcon({
  displayName: 'CheckCircleOutLine',
  viewBox: '0 0 14 14',
  path: [
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2713_24204)">
        <path
          d="M6.9974 12.8329C10.2191 12.8329 12.8307 10.2213 12.8307 6.99959C12.8307 3.77793 10.2191 1.16626 6.9974 1.16626C3.77573 1.16626 1.16406 3.77793 1.16406 6.99959C1.16406 10.2213 3.77573 12.8329 6.9974 12.8329Z"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M4.08203 7.58293L5.83203 9.33293L9.91536 4.66626"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_2713_24204">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
